import { render, staticRenderFns } from "./OtaBookingListTemplate.vue?vue&type=template&id=09db235c"
import script from "./OtaBookingListTemplate.vue?vue&type=script&lang=js"
export * from "./OtaBookingListTemplate.vue?vue&type=script&lang=js"
import style0 from "./OtaBookingListTemplate.vue?vue&type=style&index=0&id=09db235c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports